import { createStyles } from '@material-ui/core';

export default createStyles(({ palette, typography, customStyles }) => ({
  row: {
    '& td': {
      fontSize: customStyles.tableRow.fontSize,
      padding: customStyles.tableRow.padding,
      '&:not(last-child)': {
        borderLeft: `1px solid ${palette.grey.medium}`
      }
    }
  },
  groupRow: {
    backgroundColor: palette.grey.light,
    '& td': {
      fontSize: '.9rem',
      fontWeight: typography.fontWeightBold
    }
  },
  negative: {
    color: palette.error.main
  }
}));
